import { useState } from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { GetDatoModulesQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import OneVideoModal from 'modules/marketplace_modules/components/OneBanner/_OneVideoModal'
import Card from 'modules/marketplace_modules/components/PromotionContent/_Card'
import { SelfUpsellProvider } from 'modules/upsell/store/SelfUpsellProvider'

type ModulesDatoModule = NonNullable<
  GetDatoModulesQuery['modules']['datoModulesConnection']['nodes'][number]
>

type Props = {
  modules: ModulesDatoModule[]
  hideGradient: boolean
}

const Header = ({ modules, hideGradient }: Props) => {
  const [isOneVideoOpen, setIsOneVideoOpen] = useState(false)

  return (
    <>
      <Box flexDirection="row" gap="s64" alignItems="center" paddingY="s48">
        <Box
          flexDirection="column"
          gap="s4"
          paddingLeft="s24"
          style={{
            maxWidth: '458px',
            minWidth: '458px',
          }}
        >
          <Tag inline>{i18n.t('marketplace.black_friday_promo.marketplace_list.title_tag')}</Tag>
          <Text size="600" color="white" weight="semibold">
            {i18n.t('marketplace.black_friday_promo.marketplace_list.title')}
          </Text>
          <Text size="400" color="white">
            {i18n.t('marketplace.black_friday_promo.marketplace_list.description_1')}{' '}
            <span
              onClick={() => {
                setIsOneVideoOpen(true)
              }}
              style={{
                fontWeight: 500,
                textDecoration: 'underline',
                textDecorationStyle: 'dotted',
                cursor: 'pointer',
              }}
            >
              {i18n.t('marketplace.black_friday_promo.marketplace_list.description_2')}
            </span>{' '}
            {i18n.t('marketplace.black_friday_promo.marketplace_list.description_3')}
          </Text>
        </Box>
        <Box
          style={{
            position: 'relative',
            flex: '1',
            overflow: 'hidden',
          }}
        >
          <Box
            flexDirection="row"
            gap="s12"
            style={{
              overflowX: 'auto',
              overflowY: 'hidden',
              flexWrap: 'nowrap',
              scrollbarWidth: 'none',
              position: 'relative',
            }}
          >
            {modules.map((module) => (
              <SelfUpsellProvider
                key={module.id}
                availableAddons={module.billingAddonReference || []}
                availableCrossSellingAddons={module.crossSellingBillingAddonReference || []}
                availableMandatoryCrossSellingAddons={module.mandatoryCrossSellingAddons || []}
                moduleName={module?.chargebeeModuleName || ''}
              >
                <Card item={module} isHeaderCard />
              </SelfUpsellProvider>
            ))}
          </Box>
          {(modules.length > 1 || hideGradient) && (
            <Box
              style={{
                position: 'absolute',
                right: '0',
                top: '0',
                bottom: '0',
                width: '150px',
                background:
                  'linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(26,14,31,0.1) 20%, rgba(26,14,31,0.3) 40%, rgba(26,14,31,0.6) 70%, rgba(26,14,31,0.85) 90%, rgba(26,14,31,1) 100%)',
                pointerEvents: 'none',
                zIndex: '10',
              }}
            />
          )}
        </Box>
      </Box>
      <OneVideoModal isOpen={isOneVideoOpen} onClose={() => setIsOneVideoOpen(false)} />
    </>
  )
}

export default Header
